import Catchword from './Catchword'
import EverythingWrapper from './EverythingWrapper'
import ExtraDataWrapper from './ExtraDataWrapper'
import ImageOverlayWrapper from './ImageOverlayWrapper'
import ImageWrapper from './ImageWrapper'
import OuterWrapper from './OuterWrapper'
import TextWrapper from './TextWrapper'
import Title from './Title'
import VideoInfo from './VideoInfo'
import VideoInfoBig from './VideoInfoBig'

const exports = {
  Catchword,
  EverythingWrapper,
  ExtraDataWrapper,
  ImageOverlayWrapper,
  ImageWrapper,
  OuterWrapper,
  TextWrapper,
  Title,
  VideoInfo,
  VideoInfoBig,
}

export default exports
